import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-200/50 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl" style={{ color: `oklch(var(--primary-500))` }}></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-900">妖精漫画</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              妖精漫画作为免费阅读韩漫官网，为您提供海量韩国漫画作品任你选。分类清晰、更新及时，随时随地畅享韩漫阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-categories" className="hover:text-primary-600 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-quick-links" className="hover:text-primary-600 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">全部作品</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-contact" className="hover:text-primary-600 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span>contact@yaojingmanhua.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-customer-service-line text-sm"></i>
                </div>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 妖精漫画 - 免费阅读韩漫官网。本站所有内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}